import { useState } from "react";

const useWizard = ({ config }) => {
  const [marker, setMarker] = useState(0);

  const flattenSteps = (steps, parentId = "", parentIdx = -1) => {
    return steps.reduce((acc, step, stepIdx) => {
      const currentId = parentId ? `${parentId}.${stepIdx}` : `${stepIdx}`;
      if (step.steps) {
        acc = acc.concat(flattenSteps(step.steps, currentId, stepIdx));
      } else {
        acc.push({
          ...step,
          flatIdx: currentId,
          topLevel:
            parentId === "" ||
            ((parentIdx === 0 || parentId.split(".").length === 1) &&
              stepIdx === 0),
        });
      }
      return acc;
    }, []);
  };

  const handleToStart = () => {
    setMarker(0);
  };

  const handleNext = () => {
    setMarker((state) => (state < flattenedSteps.length - 1 ? state + 1 : 0));
  };

  const handleBack = () => {
    setMarker((state) => Math.max(state - 1, 0));
  };

  const handleNextTop = () => {
    setMarker((state) => {
      let i;
      for (i = state + 1; i < flattenedSteps.length; i++) {
        if (flattenedSteps[i].topLevel) return i;
      }
      return 0;
    });
  };

  const handleGoTo = (idx) => {
    setMarker(idx);
  };

  const flattenedSteps = flattenSteps(config?.steps);
  return {
    steps: flattenedSteps,
    marker,
    handleToStart,
    handleNext,
    handleBack,
    handleNextTop,
    handleGoTo,
  };
};

export default useWizard;
